/* hooks/useMailingListSignup.ts */
import { ErrorOption } from 'react-hook-form';

type ListNames = 'PROSPECT' | 'DAILY' | 'WEEKLY';
export interface OnSubmitData {
  emailAddress: string;
  referralSource:
    | 'coming soon page'
    | 'blog page'
    | 'blog detail page'
    | 'sign up';
  listName?: ListNames;
}

type OnSubmitReturn =
  | {
      success: true;
    }
  | {
      success: false;
      error: ErrorOption;
    };

export default function useMailingListSignup(): (
  data: OnSubmitData
) => Promise<OnSubmitReturn> {
  const createError = (message: string): ErrorOption => ({
    type: 'api',
    message: message
  });
  return async function (data: OnSubmitData) {
    try {
      // analytics.track.generateLead();
      const response = await fetch('/api/subscribe', {
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      });
      const result = await response.json();
      if (result.success) {
        return {
          success: true
        };
      } else {
        return {
          success: false,
          error: createError(result.error)
        };
      }
    } catch (error) {
      return {
        success: false,
        error: createError('There was an error! Please try again later.')
      };
    }
  };
}
